<template>
    <div id="theme-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Ambis Test',
                    to: { path: '/ambis-test' },
                    exact: true,
                },
                {
                    text: !$route.query.id
                        ? 'Tambah Tema Skala'
                        : 'Ubah Tema Skala',
                },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Ambis Test</h3>

        <v-card style="border">
            <v-card-title>
                {{ !$route.query.id ? "Tambah" : "Ubah" }} Tema
                Skala</v-card-title
            >
            <v-divider />
            <v-card flat class="d-flex">
                <v-col cols="3" class="py-0">
                    <v-card flat>
                        <v-card-text class="pa-0 my-2">
                            <v-card
                                flat
                                class="border-bottom-divider rounded-tl pa-0"
                            >
                                <a href="javascript:;">
                                    <img
                                        :src="
                                            url
                                                ? url
                                                : data.image && data.image != ''
                                                ? data.image
                                                : require('@/assets/img/unavailable.png')
                                        "
                                        :key="keyimg"
                                    />
                                </a>
                            </v-card>
                        </v-card-text>
                        <v-card-text class="pa-0 my-2">
                            <v-btn
                                @click="$refs.uploader.click()"
                                block
                                class="pa-0 font-weight-bold dark--text"
                                color="white"
                            >
                                Upload Foto
                            </v-btn>
                            <input
                                id="photo_tema_skala"
                                type="file"
                                ref="uploader"
                                class="d-none"
                                accept="image/*"
                                @change="onFileChange"
                            />
                        </v-card-text>
                        <v-card-text
                            class="text-caption pa-0 d-flex justify-center mb-5"
                        >
                            Rasio thumbnail foto 16:9 (HD)
                        </v-card-text>
                        <!-- <v-card-text class="text-caption pa-0 d-flex justify-center">
              Maximum size is 200 KB
            </v-card-text> -->
                    </v-card>
                </v-col>
                <v-col cols="9" style="border-left: 1px solid #f0f0f0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Nama Tema
                                    </v-list-item-title>

                                    <v-text-field
                                        v-model="data.theme_name"
                                        placeholder="Nama Tema"
                                        required
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title class="font-weight-bold">
                                        Jenis User
                                    </v-list-item-title>

                                    <v-radio-group
                                        row
                                        v-model="data.target_user"
                                    >
                                        <v-radio
                                            id="tema_user_student"
                                            label="Student"
                                            value="student"
                                            class="radio-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                        <v-radio
                                            id="tema_user_teacher"
                                            label="Teacher"
                                            value="teacher"
                                            class="radio-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                        <v-radio
                                            id="tema_user_parent"
                                            label="Parent"
                                            value="parent"
                                            class="radio-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line>
                                <v-list-item-content class="pa-0 mt-3">
                                    <v-list-item-title class="font-weight-bold">
                                        Tipe Soal
                                    </v-list-item-title>

                                    <v-radio-group row v-model="data.type">
                                        <v-radio
                                            id="tema_type_tryout"
                                            label="Tryout"
                                            value="tryout"
                                            class="radio-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                        <v-radio
                                            id="tema_type_non_tryout"
                                            label="Non Tryout"
                                            value="non_tryout"
                                            class="radio-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-list-item-content>
                            </v-list-item>
                        </v-card-text>
                        <v-card-actions class="pa-4">
                            <v-spacer></v-spacer>
                            <v-btn
                                :loading="isLoading"
                                id="oss_config_android_banner_simpan"
                                depressed
                                class="px-6 py-2 white--text"
                                color="blew"
                                @click="upload()"
                                >Simpan</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-card>
        </v-card>
    </div>
</template>

<script>
import AWS from "aws-sdk";
import { applyOssCredentials } from "@/modules/global/services/oss";
import Spinner from "@/components/plugins/Spinner";
import uniqid from "uniqid";
import ambis_test from "../services/ambis_test";

export default {
    name: "android-banner-form",

    components: {
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            errors: [],
            isLoading: false,
            selectedPicture: null,
            data: {
                theme_name: "",
                theme_description: "",
                theme_picture: "",
                target_user: "",
                type: "",
            },
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
            url: null,
            addNew: false,
            keyimg: 0,
            imageFile: null,
            tumbnail: null,
            onDelete: false,
        };
    },

    mounted: function () {
        if (this.$route.query.id) {
            this.getDetailTheme();
        }
    },

    methods: {
        onFileChange(e) {
            const file = e.target.files[0];

            if (file.size > 200000) {
                this.$store.commit("showAlert", {
                    message: `File lebih besar dari 200 KB!`,
                    type: "error",
                });
                return;
            }

            this.imageFile = file;
            this.keyimg++;
            this.url = URL.createObjectURL(file);
        },

        async upload(e = 0) {
            this.isLoading = true;
            const fileImage = this.$refs.uploader.files[0];

            // if (this.imageFile && !this.data.image) {
            //   if (!fileImage) {
            //     this.$store.commit("showAlert", {
            //       message: `Gambar tema harus diisi!`,
            //       type: "error",
            //     });
            //     return;
            //   }
            // }

            if (this.validateForm()) {
                var file = this.imageFile;
                if (this.data.theme_picture && !file) {
                    this.save();
                } else {
                    if (!file) return;
                    if (file.type.indexOf("image") == -1) return;

                    try {
                        await applyOssCredentials(AWS);
                    } catch (error) {
                        this.$store.commit("showAlert", {
                            message: `Terjadi kesalahan`,
                            submessage: error.message,
                            type: "error",
                        });
                        this.isLoading = false;
                        return;
                    }

                    var spaceEndpoint = process.env.VUE_APP_OSS_END_POINT;
                    var bucket = new AWS.S3({
                        endpoint: spaceEndpoint,
                    });

                    var params = {
                        Bucket: process.env.VUE_APP_OSS_BUCKET,
                        Key:
                            "ambis_test/theme_" +
                            new Date().valueOf() +
                            "_" +
                            file.name,
                        Body: file,
                        ContentType: file.type,
                        ACL: "public-read",
                    };

                    var context = this;
                    bucket.upload(params, function (error, data) {
                        if (error) {
                            context.$store.commit("showAlert", {
                                message: `Terjadi kesalahan`,
                                submessage: error,
                                type: "error",
                            });
                            context.isLoading = false;
                        } else {
                            context.data.theme_picture = data.Location;
                            context.save();
                        }
                    });
                }
            } else {
                this.isLoading = false;
            }
        },

        async save() {
            var context = this;
            const theme_id = context.$route.query.id;
            context.data.theme_description = context.data.theme_name;

            if (this.validateForm()) {
                if (!theme_id) {
                    ambis_test.addTheme(this.data, function (result) {
                        if (result.success) {
                            context.$store.commit("showAlert", {
                                message: `Berhasil Menyimpan Data!`,
                                type: "success",
                            });
                        }
                        context.$router.push("/ambis-test");
                    });
                } else {
                    ambis_test.editTheme(
                        theme_id,
                        this.data,
                        function (result) {
                            if (result.success) {
                                context.$store.commit("showAlert", {
                                    message: `Berhasil Menyimpan Data!`,
                                    type: "success",
                                });
                                context.$router.push("/ambis-test");
                            }
                        }
                    );
                }
            }
        },

        getDetailTheme() {
            var context = this;
            const theme_id = context.$route.query.id;

            ambis_test.getDetailTheme(theme_id, function (result) {
                if (result.success) {
                    const data = result.data;

                    context.data = {
                        theme_name: data.theme_name,
                        theme_description: data.theme_description,
                        theme_picture: data.theme_picture,
                        target_user: data.target_user,
                        type: data.type || "non_tryout",
                    };

                    context.url = data.theme_picture;
                }
            });
        },

        handleChangePicture: function (event) {
            const file = event.target.files[0];
            this.selectedPicture = file;
            this.data.picture = URL.createObjectURL(file);
        },

        validateForm() {
            var err = false;
            if (!this.url) {
                this.$store.commit("showAlert", {
                    message: `Gambar tema harus diisi`,
                    type: "error",
                });
                err = true;
            } else if (!this.data.theme_name) {
                this.$store.commit("showAlert", {
                    message: `Nama tema wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.data.target_user) {
                this.$store.commit("showAlert", {
                    message: `Target user wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.data.type) {
                this.$store.commit("showAlert", {
                    message: `Tipe soal wajib diisi!`,
                    type: "error",
                });
                err = true;
            }
            return !err;
        },

        characterCounter: function (text) {
            text = text.replace(/<[^>]*>/g, "");
            text = text.replace(/\&nbsp;/g, " ");
            return text.length;
        },
    },
};
</script>

<style>
.ck-content {
    min-height: 120px;
}

.radio-selection {
    background: #fbfbfb;
    border: 1px solid #ebebeb;
    box-sizing: border-box;
    border-radius: 100px;
}
</style>



// WEBPACK FOOTER //
// ThemeForm.vue?27a8810e